import { StorageUsage } from './storage-usage.model';

export class MemoryDiskUsage {
	public memory: StorageUsage;
	public disk: StorageUsage;
	constructor() {
		this.memory = new StorageUsage();
		this.disk = new StorageUsage();
	}
}
